import { AuthManager } from './auth.class';

export { ZMG_AUTH_STATE_CHANGED_EVENT, type AuthState } from './auth.class';

// Create singleton instance
export const authManager = new AuthManager();

// Re-export with same API
export const emptyState = authManager.emptyState;
export const setAuthState = authManager.setAuthState;
export const waitUntilReady = authManager.waitUntilReady;
export const authState = authManager.authState;
export const startRefreshingTokens = authManager.startRefreshingTokens;

// Initialize on load
if (typeof window !== 'undefined') {
    authManager.init();
}
